import { Store } from "./rootReducer";

//Types
export enum NavType {
  "TITLE_AND_BACK" = "TITLE_AND_BACK",
  "JOB_BOARD" = "JOB_BOARD",
  "LOGIN" = "LOGIN",
  "LOGGED_IN" = "LOGGED_IN",
  "APPLY_PSYCRUIT" = "APPLY_PSYCRUIT",
  "CHANGE_NAV_TYPE" = "CHANGE_NAV_TYPE",
  "NONE" = "NONE",
}

export type OtherNavData = {
  title: string;
};

// State
export type NavState =
  | {
      navType: null;
      data: null;
    }
  | {
      navType: NavType.TITLE_AND_BACK;
      data: OtherNavData;
    }
  | {
      navType: NavType.JOB_BOARD;
      data: null;
    }
  | {
      navType: NavType.LOGIN;
      data: null;
    }
  | {
      navType: NavType.LOGGED_IN;
      data: null;
    }
  | {
      navType: NavType.APPLY_PSYCRUIT;
      data: null;
    }
  | {
      navType: NavType.NONE;
      data: null;
    };

export const initialState: NavState = {
  navType: null,
  data: null,
};

// Actions
export type Action = {
  type: NavType.CHANGE_NAV_TYPE;
  payload: ChangeNavType;
};

export type ChangeNavType = {
  navType: any | null;
  data: OtherNavData | null;
};

// Reducer
export default function navReducer(
  state = initialState,
  action: Action
): NavState {
  switch (action.type) {
    case NavType.CHANGE_NAV_TYPE:
      return {
        ...state,
        navType: action.payload.navType,
        data: action.payload.data,
      };
    default:
      return state;
  }
}

// Action creators
export const changeNavType = (payload: ChangeNavType) => ({
  type: NavType.CHANGE_NAV_TYPE,
  payload,
});

//Selectors
export const selectNavType = (state: Store) => state.navbar.navType;
export const selectNavData = (state: Store) => state.navbar.data;
